import * as actions from './survey.actions'

const initialState = {
  responseOK: false,
  responseError: false,
}

const actionsMap = {
  [actions.CLEAR_RESPONSE]: (state) => {
    return {
      ...state,
      responseOK: false,
      responseError: false,
    }
  },
  [actions.ADD_OK_RESPONSE]: (state, action) => {
    let response = action.data

    return {
      ...state,
      responseOK: response,
    }
  },
  [actions.ADD_ERROR_RESPONSE]: (state, action) => {
    let response = action.data

    return {
      ...state,
      responseError: response,
    }
  },
}

/* eslint require-jsdoc: 0 */
export default function reducer(state = initialState, action = {}) {
  const fn = actionsMap[action.type]
  return fn ? fn(state, action) : state
}
